export default {
    install(app) {
        app.config.globalProperties.$uploadUrl = process.env.VUE_APP_UPLOAD_URL;
        app.config.globalProperties.$discountPrecentDefaut = 0.95;
        app.config.globalProperties.$discountPrecentAdditional = 0.95;
    },
};
